const baseUrl = '/payment/api/'; // NOTE: redundant defines on request service creation

export const paymentRoutes = {
  accountReceivable: "report/account-receivable-v2",
  accountReceivableByPropertyId: propertyId => "report/account-receivable-v2/".concat(propertyId),
  baseUrl: "".concat(baseUrl),
  download: propertyId => "report/account-receivable/".concat(propertyId, "/download"),
  downloadARCombined: "report/account-receivable/download",
  sendReport: 'report/account-receivable/send-email',
  // NOTE: for aggregate api
  reimbursmentFilters: "reports/filters/reimbursement",
  // NOTE: for Payment api
  reimbursmentReport: "report/reimbursement/report",
  reimbursmentReportV2: "report/reimbursement/report-v2",
  reimbursmentReportSlim: "report/reimbursement/report-slim",
  reimbursementReceipt: propertyId => "report/reimbursement/receipt/".concat(propertyId),
  reimbursementReceiptPeriods: propertyId => "report/reimbursement/receipt/".concat(propertyId, "/periods"),
  reimbursementReceiptDownload: propertyId => "report/reimbursement/receipt/".concat(propertyId, "/download"),
  chargeExportDownload: propertyId => "report/charge-export/".concat(propertyId, "/download")
};